import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetGQL, AssetsGQL, Asset, AssetList } from '../gql/generated';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class AssetService {
  constructor(
    private assetGQL: AssetGQL,
    private assetsGQL: AssetsGQL,
    private loaderService: LoaderService
  ) {}

  /**
   * Fetch a single asset by ID
   */
  getAsset(id: string): Observable<Asset | null> {
    return this.loaderService.withLoader(() =>
      this.assetGQL.fetch(
        { id },
        {
          context: {
            headers: {
              'vendure-token': 'K7',
            },
          },
          fetchPolicy: 'network-only',
        }
      ).pipe(
        map(result => result.data.asset as Asset || null)
      ), `asset-${id}`
    );
  }

  /**
   * Fetch multiple assets with filtering options
   */
  getAssets(ids: string[]): Observable<AssetList | null> {
    return this.loaderService.withLoader(() =>
      this.assetsGQL.fetch(
        {
          ids
        },
        {
          context: {
            headers: {
              'vendure-token': 'K7',
            },
          },
          fetchPolicy: 'network-only',
        }
      ).pipe(
        map(result => result.data.assets as AssetList || null)
      ), `asset-${ids.join('-')}`
    );
  }

  /**
   * Fetch multiple assets by their IDs
   */
  getAssetsByIds(ids: string[]): Observable<AssetList | null> {
    return this.getAssets(ids);
  }
}
